/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
// Material Kit 2 React examples
//import RotatingCard from "./RotatingCard";
//import RotatingCardFront from "./RotatingCardFront";
//import RotatingCardBack from "./RotatingCardBack";
//import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
//import MKTypography from "components/MKTypography";
import { useTranslation } from "react-i18next";
// Images
//import bgFront from "assets/images/rotating-card-bg-front.jpeg";
//import bgBack from "assets/images/rotating-card-bg-back.jpeg";
import kunnat from "kunnat";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
/* eslint-disable react/prop-types */
const Information = ({ selectedKunta, setSelectedKunta }) => {
  const [t] = useTranslation("common");
  //console.log(kunnat);
  //console.log(setSelectedKunta);
  const getKunnat = (kunn) =>
    kunn.map((kunt) => {
      return (
        <MenuItem value={kunt.name} key={kunt.name}>
          {kunt.name}
        </MenuItem>
      );
    });
  //console.log(selectedKunta);

  return (
    <FormControl fullWidth>
      <InputLabel id="municipality">{t("common.municipality")}</InputLabel>
      <Select
        labelId="muni-select-label"
        id="muni-select"
        value={selectedKunta}
        label={t("common.municipality")}
        onChange={(e) => setSelectedKunta(e.target.value)}
        style={{ backgroundColor: "white" }}
      >
        {getKunnat(kunnat)}
      </Select>
    </FormControl>
  );
};

export default Information;

/**
 * 
 * <MKTypography
        variant="body1"
        color="black"
        textAlign="left"
        style={{ backgroundColor: "white" }}
      >
        {t("common.municipality")}
      </MKTypography>
 */
/**
 * 
 * <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="touch_app"
                title={
                  <>
                    {t("common.information")}
                    <br />
                    {t("common.aboutmunicipalities")}
                  </>
                }
                description={t("common.descriptioncard")}
              />
              <RotatingCardBack
                image={bgBack}
                title={t("common.moreinfo")}
                description={t("common.descriptioncardback")}
                action={{
                  type: "internal",
                  route: "/sections/page-sections/page-headers",
                  label: t("instructions.contactheader"),
                }}
              />
            </RotatingCard>
          </Grid>
 */
